const className = 'loading-animation';

/**
 * Обновляет состояние анимационной загрузки
 *
 * @param {Boolean} start
 * @param {Element} el
 */
const toggleLoading = (start, el = null) => {
    if (!el) {
        el = document.body;
    }

    if (el.classList.contains('loading-process') && start) return;

    let loaderElement;

    if (start) {
        el.classList.add('loading-process');

        loaderElement = document.createElement('div');
        loaderElement.classList.add(className);

        el.insertBefore(loaderElement, el.childNodes[0]);

        return;
    }

    loaderElement = el.querySelector(`.${className}`);

    el.classList.remove('loading-process');

    if (loaderElement) {
        el.removeChild(loaderElement);
    }
};

export default toggleLoading;
